<template>    
    <v-dialog
      v-model="dialog"
      width="500"
    >      
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
            Proyecto            
        </v-card-title>
        
        <v-layout wrap align-center>
            <v-flex xs12 sm10 offset-sm1>
                <v-autocomplete
                    v-model="customer"
                    :items="customers"
                    :item-text="customerCaption"
                    item-value="no"
                    dense
                    filled
                    label="Seleccione un Cliente (opcional)"
                    clearable
                ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm10 offset-sm1>                
                <v-autocomplete
                    v-model="proyecto"
                    :items="proyectos"
                    :item-text="jobCaption"
                    item-value="no"
                    dense
                    filled
                    label="Seleccione un Proyecto"
                    clearable
                ></v-autocomplete>
            </v-flex>            
        </v-layout>                

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>          
          <v-btn
            color="primary"
            text
            @click="closeOK"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>  
</template>
<script>
export default {
    name: 'dialogProyecto',
    data () {
      return {              
      }
    },
    methods:{        
        close(){
            this.dialog = false;                        
        },
        closeOK(){            
            this.dialog = false;                        
        },
        jobCaption(item){
            return item.no + ' - ' + item.description;
        }, 
        customerCaption(item){
            return item.no + ' - ' + item.name;
        }
    },
    mounted(){
      
    },
    watch:{
        dialog: function(val){
            if (val){          
                this.getJobs();
                this.getCustomers();
                this.$store.commit('saveJobTasks',[]);   
            }
        },
        customer: function(val){
            if ((val == null) || (val == undefined)){
                this.$store.commit('saveCustomerFilter','');
            }
            this.getJobs();
        }
    },
    computed:{
        dialog: {
            get(){
                return this.$store.state.dialogProyecto;
            },
            set(value){
                this.$store.state.dialogProyecto = value;
            }
        },
        proyectos:{
            get(){
                return this.$store.state.jobs;
            }
        },
        proyecto:{
            get(){
                return this.$store.state.proyecto;
            },
            set(value){                
                this.$store.commit('saveJob',value);
            }
        },
        customers:{
            get(){
                return this.$store.state.customers;
            }
        },
        customer:{
            get(){
                return this.$store.state.customerFilter;
            },
            set(value){                
                this.$store.commit('saveCustomerFilter',value);
            }
        }
    }
}
</script>


